import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductlistingService {


  url = environment.serverAPI4 + "/api/productlisting"; 
  
  constructor(private http: HttpClient) { }

  getAllProductlisting(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllProductlistingDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getProductlistingById(productListingId: number): Observable<Object> {
    return this.http.get(`${this.url}/${productListingId}`);
  }

  addOrEditProductlisting(productlisting: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, productlisting);
  }

  ProductlistingSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteByProductlistingId(id: any): Observable<Object> {
		return this.http.delete(`${this.url}/${id}`);
	}

}
